<template>
    <b-dropdown 
        no-flip
        v-on:shown="toggleClass = 'open'"
        v-on:hidden="toggleClass='hidden'; filter=''"
        :toggle-class="toggleClass" 
        @shown="focusSearchBar"
        menu-class="rounded shadow w-100" 
        variant="white border search-dropdown" 
        class="w-100 search-dropdown-container d-relative">
        <template slot="button-content" class="p-0 bg-white search-dropdown">
            <div v-if="valueLabel.length" class="value">
                {{ valueLabel }}
            </div>
            <div v-else class="text-muted value">
                {{ placeholder }}
            </div>
        </template>
        <b-dropdown-header>
            <b-input-group size="sm">
                <b-form-input type="text" placeholder="Search" ref="searchBar"
                v-model="filter" :class="{ 'border-warning': filter }" />
                <b-input-group-text class="py-0" slot="append" :class="{ 'border-warning': filter }">
                    <i class="icon icon-Search h4 p-0 m-0" 
                        :class="{ 'text-warning': filter }" />
                </b-input-group-text>
            </b-input-group>
        </b-dropdown-header>
        <b-dropdown-item
            v-for="option in filteredOpts"
            :class="{ 'selected': optionSelected(option) }"
            class="pr-5"
            :key="option[optionValueField]"
            @click="select(option)">
            {{ option[optionLabelField] }}
        </b-dropdown-item>
        <b-dropdown-item 
            v-if="!filteredOpts.length"
            disabled>
            No data available
        </b-dropdown-item>
    </b-dropdown>
</template>

<style>
.search-dropdown .value {
    padding-right: 40px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.search-dropdown {
    cursor: pointer !important;
    width: 100% !important;
    padding: 0;
}
.search-dropdown.btn {
    text-align: left;
    padding-left: 1em;
}
.search-dropdown.dropdown-toggle::after {
    display: none !important;
}
.search-dropdown-container.show button.dropdown-toggle {
    background-color: #FFF !important;
}
.search-dropdown-container::after {
    position: absolute;
    font-size: 1.85em;
    font-family: icomoon;
    content: "\e906";
    color: #C3CBD2;

    right: 0px;
    top: 0px;
    bottom: 0px;
    width: 43px;
    padding-left: 4px;
    background-color: var(--light);
    border-top-right-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
    border: 2px solid var(--border);
    z-index: 100;
    pointer-events: none;
}
.search-dropdown-container.show::after {
    content: "\e905";
    border-bottom-right-radius: 0rem !important;
}
.search-dropdown.open {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
}
.search-dropdown-container .dropdown-menu {
    top: -4px !important;
    border-top: 0px;
    border-bottom-left-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
    min-height: 6rem;
    max-height: calc(100% * 5 + 1.5rem);
    overflow-y: scroll;
}
.search-dropdown-container .dropdown-menu .selected {
    color: var(--primary);
    position: relative;
}
.search-dropdown-container .dropdown-menu .selected::after {
    font-family: icomoon;
    position: absolute;
    right: 5px;
    top: -10px;
    font-size: 2.5em;
    content: "\e912";
    color: var(--primary);
    background-image: none;
}
.search-dropdown-container {
    height: 44px;
    position: relative;
}
</style>

<script>
export default {
    props: {
        /* options in [ { value:, label: } ] format */
        options: { required: true, type: [ Array, Object ]},
        value: { required: true, type: String },
        valuesOnly: { required: false, default: false, type: Boolean }, /* values array will be literals not objecy val/label */
        optionValueField: { required: false, default: 'value', type: String },
        optionLabelField: { required: false, default: 'label', type: String },
        optionsKeyIsValue: { required: false, default: true, type: Boolean },
        placeholder: { type: String, default: '' }
    },
    data () {
        return {
            toggleClass: 'hidden', /* use to remove bottom radius during open */
            filter: ''
        }
    },
    methods: {
        emitValue (value) {
            this.$emit('input', value)
        },
        focusSearchBar () {
            let self = this
            this.$nextTick().then(function() { self.$refs.searchBar.$el.focus() })
        },
        label (val) {
            let lfield = this.optionLabelField
            if (lfield in val) {
                return val[lfield]
            }
            return val
        },
        optionSelected (option) {
           return (this.value === option[this.optionValueField])
        },
        select (option) {
            if (this.valuesOnly) {
                this.emitValue(option)
            } else {
                this.emitValue(option[this.optionValueField])
            }
        },
    },
    computed: {
        valueLabel () {
            if (this.valuesOnly) {
                return this.value
            } else {
                let option = this.options.find(opt => opt[this.optionValueField] === this.value)
                if(option) {
                    return option[this.optionLabelField]
                } else {
                    return ''
                }
            }
        },
        labelMapping () {
            let options = this.options

            let map = {}
            if (Array.isArray(options)) {
                if (!options.length) {
                    return map /* nothin to do dood */
                }
                if (typeof options[0] !== 'object') {
                    for (let literal of options) {
                        map[literal] = literal
                    }
                    return map
                }

                let vfield = this.optionValueField
                let lfield = this.optionLabelField

                for (let entry of options) {
                    map[entry[vfield]] = entry[lfield]
                }
            } else if (typeof options === 'object') {
                if (this.optionsKeyIsValue) {
                    return options /* already flat mapping of value:label */
                } else {
                    for (let key in options) {
                        map[options[key]] = key
                    }
                }
            }

            return map
        },
        opts () {
            let options = this.options

            let vfield = this.optionValueField
            let lfield = this.optionLabelField

            if (Array.isArray(options)) {
                if (!options.length) {
                    return []
                }

                let first = options[0]
                if (typeof first === 'object') {
                    return this.options
                }

                /* flat array, transform into key,label object format */
                let opts = []
                for (let literal of options) {
                    let item = {}
                    item[vfield] = literal
                    item[lfield] = literal
                    opts.push(item)
                }

                return opts
            }

            if (typeof options === 'object') {
                /* options just an object, map the k:v pairs
                to our array of { value: .., label: .. } objects */
                let opts = []
                for (let key in options) {
                    let kIsVal = this.optionsKeyIsValue
                    let value = options[key]

                    let item = {}
                    if (kIsVal) {
                        item[vfield] = key
                        item[lfield] = value
                    } else {
                        item[vfield] = value
                        item[lfield] = key
                    }

                    opts.push(item)            
                }

                return opts
            }
            
        },
        filteredOpts () {
            let filter = this.filter

            if (!filter) {
                filter = ''
            }
            filter = filter.toLowerCase()

            return this.opts.filter((opt) => {
                //disqualify any items without both val and label
                if (!(this.optionValueField in opt) || !(this.optionLabelField in opt)) {
                    return false
                }

                let val = opt[this.optionValueField].toLowerCase()
                let label = opt[this.optionLabelField].toLowerCase()
                
                return (val.indexOf(filter) !== -1 ||
                    label.indexOf(filter) !== -1)
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SearchDropdown.vue